// All of the requested modules are loaded behind enumerable getters.
const map = Object.defineProperties({}, {
  "./(root)/_layout.js": { enumerable: true, get() { return require("D:\\baumWiderruf\\app\\(root)\\_layout.js"); } },
  "./(root)/index.js": { enumerable: true, get() { return require("D:\\baumWiderruf\\app\\(root)\\index.js"); } },
  "./_layout.js": { enumerable: true, get() { return require("D:\\baumWiderruf\\app\\_layout.js"); } },
});

function metroContext(request) {
    return map[request];
}

// Return the keys that can be resolved.
metroContext.keys = function metroContextKeys() {
  return Object.keys(map);
};

// Return the module identifier for a user request.
metroContext.resolve = function metroContextResolve(request) {
  throw new Error('Unimplemented Metro module context functionality');
}

module.exports = metroContext;